export default "Dictionary\n\n<router-outlet></router-outlet>\n"